import clsx from 'clsx';

export const CurrencySign = ({ value }: { value: string }) => (
  <span className={clsx('inline-block', { 'text-[0.67em] align-middle': value === '⭐' })}>{value}</span>
);
